import {BrowserRouter , Routes, Route} from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import LoginPage from './Pages/login';
import ProtectedRoute from './Pages/common/ProtectedRoute';
import SideMenu from './Layouts/SideMenu';
import { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import Clients from './Pages/Clients';
import TaxReturns from './Pages/TaxReturns';
import W2s from './Pages/W2s';
import Client1099Divs from './Pages/1099Divs';
import Client1099Ints from './Pages/1099Ints';
import Client1099Bs from './Pages/1099Bs';
import K1s from './Pages/K1s';
import Rentals from './Pages/Rentals';
import Tasks from './Pages/Tasks';
import TaskTaxTopics from './Pages/TaskTaxTopics';
import TaxDocuments from './Pages/TaxDocuments';
import { Dropdown } from 'primereact/dropdown';
import { getDataApi1, loadApi, saveApi, loadApi1, saveApi1, delApi1} from "./services/appApi";

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSessionPopup, setShowSessionPopup] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
  const [selectedClientId, setSelectedClientId] = useState(localStorage.getItem("taxSelectedClientId") || null);
    const [selectedClientName, setSelectedClientName] = useState(localStorage.getItem("taxSelectedClientName") || null);
    const [selectedTaxYear, setSelectedTaxYear] = useState(localStorage.getItem("taxSelectedTaxYear") || null);
    const [clientOptions, setClientOptions] = useState([]);
    const [taxYearOptions, setTaxYearOptions] = useState([]);
    const userId = localStorage.getItem("taxUserId");
    const firmId = localStorage.getItem("taxFirmId");
    const token = localStorage.getItem("taxToken");

  useEffect(()=> {
    const token = localStorage.getItem("taxToken");
    const expiryTime = localStorage.getItem("taxExpiryTime");
    if(!token || !expiryTime) {
      return;
    }
    const currentTime = new Date().getTime();
    const remainingTime = Number(expiryTime) - currentTime;
    if(remainingTime <= 0) {
      localStorage.clear();
      sessionStorage.setItem("taxSessionExpired", "true");
      setShowSessionPopup(true);
      return;
    }
    const timer = setTimeout(() => {
      localStorage.clear();
      sessionStorage.setItem("taxSessionExpired", "true");
      setShowSessionPopup(true);
    }, remainingTime);
    return () => clearTimeout(timer);
  }, [navigate]);

  useEffect(() => {
    const syncSelection = () => {
      setSelectedClientId(localStorage.getItem("taxSelectedClientId") || null);
      setSelectedClientName(localStorage.getItem("taxSelectedClientName") || null);
      setSelectedTaxYear(localStorage.getItem("taxSelectedTaxYear") || null);
    };

    window.addEventListener("taxSelectionChanged", syncSelection);
    return () => window.removeEventListener("taxSelectionChanged", syncSelection);
  }, []);

  useEffect(() => {
    if (!userId || !firmId) {
      setClientOptions([]);
      return;
    }

                     const fetchClient = async () => {
                       try {
                         let offset = 0;
                         let limit = 25;
                         let hasMore = true;
                         let allData = [];
                         let status = null;
                         while (hasMore) {
                           const response = await getDataApi1(
                             `/ztx_firm_clients_v/v1/?p_user_id=${encodeURIComponent(userId)}&p_firm_id=${encodeURIComponent(firmId)}&offset=${offset}&limit=${limit}`,
                           );
                           allData = [...allData, ...response.data.o_return_data_rc];
                           status = response.status;
                           hasMore = response.data.hasMore;
                           offset = offset + limit;
                         }
                         if (allData.length > 0) {
                           const options = allData.map((item) => ({
                             label: item.client_first_name,
                             value: String(item.client_id),
                           }));
                           setClientOptions(options);
                           console.log(options);
                         }
                       } catch (err) {
                         console.error(err);
                       }
                     };
                     fetchClient();
                   }, [location.pathname, userId, firmId]);

  useEffect(() => {
    if (!userId || !token) {
      setTaxYearOptions([]);
      return;
    }

    const fetchTaxYears = async () => {
      try {
        let offset = 0;
        const limit = 25;
        let hasMore = true;
        const allData = [];

        while (hasMore) {
          const response = await getDataApi1(
            `/ztx_tax_years_v/?offset=${offset}&limit=${limit}`,
          );
          const responseData = response.data;
          const pageData = Array.isArray(responseData?.o_return_data_rc)
            ? responseData.o_return_data_rc
            : Array.isArray(responseData?.items)
              ? responseData.items
              : [];

          allData.push(...pageData);
          hasMore = responseData?.hasMore === true || responseData?.hasMore === "true";
          offset += limit;
        }

        setTaxYearOptions(
          allData
            .filter((item) => item.tax_year !== null && item.tax_year !== undefined)
            .sort((first, second) => Number(second.tax_year) - Number(first.tax_year))
            .map((item) => ({
              label: String(item.tax_year),
              value: String(item.tax_year),
            })),
        );
      } catch (error) {
        console.error("Unable to fetch tax years", error);
        setTaxYearOptions([]);
      }
    };

    fetchTaxYears();
  }, [location.pathname, userId, token]);

  const handleSessionExpired = () => {
    sessionStorage.setItem("taxSessionExpired", "false");
    setShowSessionPopup(false)
    navigate("/login")
  }
   const handleClientChange = (event) => {
    const clientId = event.value || null;
    const client = clientOptions.find((option) => String(option.value) === String(clientId));
    const clientName = client?.label || "";

    setSelectedClientId(clientId);
    setSelectedClientName(clientName || null);
    localStorage.setItem("taxSelectedClientId", clientId || "");
    localStorage.setItem("taxSelectedClientName", clientName);
    window.dispatchEvent(new Event("taxSelectedClientChanged"));
  };

  const handleTaxYearChange = (event) => {
    const taxYear = event.value || null;
    setSelectedTaxYear(taxYear);
    localStorage.setItem("taxSelectedTaxYear", taxYear || "");
  };
  return (
    <div>
        <>
        <div style={{display: "flex", height: "100vh", overflow: "hidden"}}>
        {location.pathname !=="/" && location.pathname !=="/login" && <SideMenu/>}
        <div style={{flex: 1, background: "#e0f0ff", minHeight: "100vh", overflow: "auto"}}>
           <div style={{
             position: "sticky",
             top: 0,
             zIndex: 1000,
             padding: "0.5rem 0.75rem 0.25rem",
             background: "#e0f0ff",
           }}>
      {/* <select
        value={selectedClientId ?? ""}
        onChange={handleClientChange}
        style={{
          width: "100%",
          padding: "0.625rem 0.75rem",
          borderRadius: "0.5rem",
          border: "1px solid #cbd5e1",
          background: "#fff",
          color: "#0f172a",
          fontSize: "0.875rem"
        }}
      >
        <option value="">Select Client</option>
        {clientOptions.map((client) => (
          <option key={client.value} value={client.value}>
            {client.label}
          </option>
        ))}
      </select>
      {selectedClientName && (
        <div style={{ marginTop: "0.5rem", fontSize: "0.75rem", color: "#0f172a", paddingLeft: "0.25rem" }}>
          Selected: {selectedClientName}
        </div>
      )} */}
      {/* <select
        value={selectedTaxYear}
        onChange={handleTaxYearChange}
        style={{
          width: "100%",
          marginTop: "0.5rem",
          padding: "0.625rem 0.75rem",
          borderRadius: "0.5rem",
          border: "1px solid #cbd5e1",
          background: "#fff",
          color: "#0f172a",
          fontSize: "0.875rem"
        }}
      >
        <option value="">Select Tax Year</option>
        {taxYearOptions.map((taxYear) => (
          <option key={taxYear} value={taxYear}>
            {taxYear}
          </option>
        ))}
      </select> */}
      {location.pathname !=="/" && location.pathname !=="/login" &&
    <div style={{ display: "flex", gap: "16px" }}>
    <Dropdown value={selectedClientId} onChange={handleClientChange} options={clientOptions} optionLabel="label" optionValue="value" placeholder="Select Client" showClear
    filter className="w-full md:w-14rem" />
    <Dropdown value={selectedTaxYear} onChange={handleTaxYearChange} options={taxYearOptions} optionLabel="label" placeholder="Select Tax Year" showClear
    filter className="w-full md:w-14rem" />
    </div>
  }
    </div>
         <Routes key={`${selectedClientId || ""}-${selectedTaxYear || ""}`}>
          <Route path="/login" element={<LoginPage />} />
           <Route path="/">
            <Route index element={<LoginPage/>} />
          </Route>
          <Route path="/Pages/Clients">
            <Route index element={<ProtectedRoute><Clients/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/TaxReturns">
            <Route index element={<ProtectedRoute><TaxReturns/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/W2s">
            <Route index element={<ProtectedRoute><W2s/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/1099Divs">
            <Route index element={<ProtectedRoute><Client1099Divs/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/1099Ints">
            <Route index element={<ProtectedRoute><Client1099Ints/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/1099Bs">
            <Route index element={<ProtectedRoute><Client1099Bs/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/K1s">
            <Route index element={<ProtectedRoute><K1s/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/Rentals">
            <Route index element={<ProtectedRoute><Rentals/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/Tasks">
            <Route index element={<ProtectedRoute><Tasks/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/TaskTaxTopics">
            <Route index element={<ProtectedRoute><TaskTaxTopics/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/TaxDocuments">
            <Route index element={<ProtectedRoute><TaxDocuments/></ProtectedRoute>} />
          </Route>
         </Routes>
         <Dialog header="Session Expired" visible={showSessionPopup} baseZIndex={99999} closable={false} modal style={{width: '25rem'}}>
          <p>Your session has expired. Please login again.</p>
          <div className='flex justify-content-end mt-4'>
            <Button label="OK" onClick={handleSessionExpired}/>
          </div>
         </Dialog>
         </div>
         </div>
       </>
      {/* <h1>Hello World !!!</h1> */}
    </div>
  );
}

function App() {
  return (
  <BrowserRouter>
    <Layout />
  </BrowserRouter>
  );
}

export default App;